import React, { useContext } from 'react';
import classnames from 'classnames';
import { BaseContext } from '../../contexts';

const ExecutiveView = () => {
  const { initialData, paths, userGroupsActive } = useContext(BaseContext);
  const canManageExecutiveView = initialData.can_manage_executive_view;
  const executiveViewUrl = paths.executive_view;

  return (
    <>
      {
        canManageExecutiveView &&
        <li className={ classnames("sidebar_nav-list-item", { '-active': userGroupsActive }) }>
          <a
            className="sidebar_nav-link -with-icon"
            href={ executiveViewUrl }
          >
            <svg className="sidebar_nav-link-icon icon -menu-downloads">
              <use xlinkHref="#svg_menu-downloads" />
            </svg>
            <span className="sidebar_nav-link-text">Executive Snapshot</span>
          </a>
        </li>
      }
    </>
  );
};

export default ExecutiveView;
